<template>
    <app-layout>
        <template #icon>
            <div class="h-10 w-10 flex items-center justify-center">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-hand-coins"
                >
                    <path
                        stroke="url(#paint0_linear_68_19)"
                        stroke-width="1.8"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M11 15h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 17"
                    />
                    <path
                        stroke="url(#paint0_linear_68_19)"
                        stroke-width="1.8"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="m7 21 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9"
                    />
                    <path
                        stroke="url(#paint0_linear_68_19)"
                        stroke-width="1.8"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="m2 16 6 6"
                    />
                    <circle
                        cx="16"
                        cy="9"
                        r="2.9"
                        stroke="url(#paint0_linear_68_19)"
                        stroke-width="1.8"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <circle
                        cx="6"
                        cy="5"
                        r="3"
                        stroke="url(#paint0_linear_68_19)"
                        stroke-width="1.8"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <defs>
                        <linearGradient
                            id="paint0_linear_68_19"
                            x1="4.56256"
                            y1="4.33394"
                            x2="24.9101"
                            y2="26.2819"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stop-color="#FF8D47" />
                            <stop offset="0.147634" stop-color="#FF7447" />
                            <stop offset="0.454086" stop-color="#FF4247" />
                            <stop offset="0.636926" stop-color="#E92A5B" />
                            <stop offset="0.740367" stop-color="#DD1C67" />
                            <stop offset="0.842991" stop-color="#D31071" />
                            <stop offset="1" stop-color="#CF0283" />
                        </linearGradient>
                    </defs>
                </svg>
            </div>
        </template>
        <template #title> {{ $t("affiliate_partners.title") }} </template>
        <template #description>
            {{ $t("affiliate_partners.description") }}</template
        >
        <template #actions>
            <!--            <ButtonComponent>{{ $t("affiliate_partners.payout") }} </ButtonComponent>-->
        </template>

        <div class="px-4 pt-4 sm:px-6">
            <div class="gap-4 md:grid-cols-2 lg:grid-cols-4 grid">
                <Card>
                    <CardHeader
                        class="space-y-0 pb-2 flex flex-row items-center justify-between"
                    >
                        <CardTitle class="text-sm font-medium">
                            {{ $t("affiliate_partners.total_payouts") }}
                        </CardTitle>
                        <LucideWallet :size="20" class="text-gray-400" />
                    </CardHeader>
                    <CardContent>
                        <div class="text-2xl font-bold pb-2 border-b">
                            {{ totalPayout }} Kč
                        </div>
                        <div class="text-2xl font-bold py-2 border-b">
                            {{ totalPayoutEur }} €
                        </div>
                        <div class="text-2xl font-bold pt-2">
                            $ {{ totalPayoutUsd }}
                        </div>
                    </CardContent>
                </Card>
                <Card>
                    <CardHeader
                        class="space-y-0 pb-2 flex flex-row items-center justify-between"
                    >
                        <CardTitle class="text-sm font-medium">
                            {{ $t("affiliate_partners.total_signups") }}
                        </CardTitle>
                        <Users :size="20" class="text-gray-400" />
                    </CardHeader>
                    <CardContent>
                        <div class="text-2xl font-bold">
                            {{ totalSignups }}
                        </div>
                        <p class="text-xs text-muted-foreground">
                            {{ $t("affiliate_partners.out_of") }}
                            {{ totalClicks }}
                            {{
                                $t("affiliate_partners.clicks")
                                    .charAt(0)
                                    .toLowerCase() +
                                $t("affiliate_partners.clicks").slice(1)
                            }}
                        </p>
                    </CardContent>
                </Card>
                <Card>
                    <CardHeader
                        class="space-y-0 pb-2 flex flex-row items-center justify-between"
                    >
                        <CardTitle class="text-sm font-medium">
                            {{ $t("affiliate_partners.total_purchases") }}
                        </CardTitle>
                        <CreditCard :size="20" class="text-gray-400" />
                    </CardHeader>
                    <CardContent>
                        <div class="text-2xl font-bold">
                            {{ totalPurchases }}
                        </div>
                    </CardContent>
                </Card>
                <Card>
                    <CardHeader
                        class="space-y-0 pb-2 flex flex-row items-center justify-between"
                    >
                        <CardTitle class="text-sm font-medium">
                            {{ $t("affiliate_partners.to_payout") }}
                        </CardTitle>
                        <HandCoinsIcon :size="20" class="text-gray-400" />
                    </CardHeader>
                    <CardContent>
                        <div class="text-2xl font-bold pb-2 border-b">
                            {{ totalEarnings - totalPayout }} Kč
                        </div>
                        <div class="text-2xl font-bold py-2 border-b">
                            {{ totalEarningsEur - totalPayoutEur }} €
                        </div>
                        <div class="text-2xl font-bold pt-2">
                            $ {{ totalEarningsUsd - totalPayoutUsd }}
                        </div>
                        <!--                        <p v-if="(totalEarnings - totalPayout) >= 1000" class="text-xs text-muted-foreground">-->
                        <!--                            Will be sent to your bank account 01.01.2024-->
                        <!--                        </p>-->
                    </CardContent>
                </Card>
            </div>

            <div
                class="group my-4 rounded-lg border-iron-200 bg-white px-4 py-5 shadow-sm hover:shadow-md w-full border transition-all duration-200"
            >
                <Table>
                    <TableCaption>{{
                        $t(
                            "affiliate_partners.affiliate_links_table_description",
                        )
                    }}</TableCaption>
                    <TableHeader>
                        <TableRow>
                            <TableHead>
                                {{ $t("affiliate_partners.link") }}
                            </TableHead>
                            <TableHead class="text-left">{{
                                $t("affiliate_partners.percentage")
                            }}</TableHead>
                            <TableHead></TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        <TableRow
                            v-for="affiliateLink in affiliateLinks"
                            :key="affiliateLink.id"
                        >
                            <TableCell
                                class="font-medium gap-1 flex cursor-pointer items-center"
                                @click="copyToClipboard(affiliateLink.link)"
                            >
                                {{ affiliateLink.link }}
                                <ClipboardCopy
                                    v-if="!clipboard.copied.value"
                                    size="18"
                                />
                                <ClipboardCheck
                                    v-if="clipboard.copied.value"
                                    size="18"
                                />
                            </TableCell>
                            <TableCell class="text-left"
                                >{{ affiliateLink.percentage }}%</TableCell
                            >
                            <TableCell class="flex justify-end">
                                <AffiliateLinkDetail
                                    :affiliateLink="affiliateLink"
                                >
                                    <Button variant="outline">
                                        {{ $t("details") }}
                                    </Button>
                                </AffiliateLinkDetail>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </div>
        </div>
    </app-layout>
</template>

<script lang="ts" setup>
import AppLayout from "../../../../../Layouts/AppLayout.vue";
import { defineProps } from "vue";
import {
    HandCoinsIcon,
    LucideWallet,
    Users,
    CreditCard,
    ClipboardCopy,
    ClipboardCheck,
} from "lucide-vue-next";
import { Button } from "@/components/ui/button";
import {
    Table,
    TableBody,
    TableCaption,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "@/components/ui/table";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import AffiliateLinkDetail from "@/Pages/Zaptime/App/Affiliates/Partners/components/AffiliateLinkDetail.vue";
import { useClipboard } from "@vueuse/core";

const clipboard = useClipboard();

function copyToClipboard(content: string) {
    clipboard.copy(content);
}

defineProps({
    affiliateLinks: {
        required: true,
        type: Array,
    },
    totalPayout: {
        required: true,
        type: Number,
    },
    totalPayoutEur: {
        required: true,
        type: Number,
    },
    totalPayoutUsd: {
        required: true,
        type: Number,
    },
    totalEarnings: {
        required: true,
        type: Number,
    },
    totalEarningsEur: {
        required: true,
        type: Number,
    },
    totalEarningsUsd: {
        required: true,
        type: Number,
    },
    totalClicks: {
        required: true,
        type: Number,
    },
    totalSignups: {
        required: true,
        type: Number,
    },
    totalPurchases: {
        required: true,
        type: Number,
    },
});
</script>
